import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

const AUTH_STORAGE_KEY = "alpiresort-admin-token";

// Attach JWT to every request if we have one (used by admin endpoints).
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem(AUTH_STORAGE_KEY);
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    // localStorage not available (SSR, privacy mode). Skip silently.
  }
  return config;
});

// Auto-logout on 401/403 so admin UI redirects back to login.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      try {
        localStorage.removeItem(AUTH_STORAGE_KEY);
      } catch {}
    }
    return Promise.reject(error);
  }
);

// ---- Public (no auth required) ----
export const fetchRooms = () => api.get("/rooms").then((r) => r.data);
export const fetchRoom = (slug) => api.get(`/rooms/${slug}`).then((r) => r.data);
export const fetchOffers = () => api.get("/offers").then((r) => r.data);
export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchExperiences = () => api.get("/experiences").then((r) => r.data);
export const fetchReviews = () => api.get("/reviews").then((r) => r.data);
export const fetchSettings = () => api.get("/settings").then((r) => r.data);
export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);

// ---- Admin (auth required) ----
export const fetchBookings = () => api.get("/bookings").then((r) => r.data);
export const fetchBooking = (id) =>
  api.get("/bookings").then((r) => (r.data || []).find((b) => b.id === id));
